export const FRAME_ADVANCE_INTERVAL = 100;
